import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TextVisibility } from 'src/app/enums/icons/password/textVisibility.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';

@Component({
  selector: 'password-change',
  templateUrl: './password.change.dialog.html',
  styleUrls: ['./password.change.dialog.scss'],
})
export class PasswordChangeDialg implements OnInit {
  psw_visibility_old: TextVisibility = TextVisibility.HIDDEN;
  psw_visibility_new: TextVisibility = TextVisibility.HIDDEN;
  psw_visibility_repeat: TextVisibility = TextVisibility.HIDDEN;

  forced: number = 0;

  //----------------------------------------------------------------------------------------

  constructor(
    private dialogRef: MatDialogRef<PasswordChangeDialg>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _session: SessionManager
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.forced) this.forced = this.data.forced;
  }

  //----------------------------------------------------------------------------------------

  cancel() {
    this.dialogRef.close({
      code: DialogsReturnCode.PASSWORD_CHANGE_CANCELL,
    });
  }

  async continue(
    oldPassword: string,
    newPassword: string,
    repeatPassword: string
  ) {
    let response = await this.doPasswordChange(
      oldPassword,
      newPassword,
      repeatPassword
    );

    console.log(response);

    if (Result.isKind(response) && response.result == 1) {
      this.dialogRef.close({
        code: DialogsReturnCode.PASSWORD_CHANGE_ACCEPT,
      });
    }
  }

  //---------------------------------------------------------------------------------------------------

  async doPasswordChange(
    oldPassword: string,
    newPassword: string,
    repeatPassword: string
  ) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return;

    this._loader.start();

    let response = null;
    response = await this._handler
      .login()
      .passwordChange(
        (user as User).token,
        oldPassword,
        newPassword,
        repeatPassword
      );

    this._loader.stop();

    if (!response) return;

    return response;
  }

  //---------------------------------------------------------------------------------------------------

  // ============== PSW BUTTON HANDLER ================

  switchVisibilityOld() {
    if (this.psw_visibility_old == TextVisibility.HIDDEN)
      this.psw_visibility_old = TextVisibility.VISIBLE;
    else this.psw_visibility_old = TextVisibility.HIDDEN;
  }

  getPswTypeOld(): string {
    if (this.psw_visibility_old == TextVisibility.HIDDEN) return 'password';
    else return 'text';
  }

  switchVisibilityNew() {
    if (this.psw_visibility_new == TextVisibility.HIDDEN)
      this.psw_visibility_new = TextVisibility.VISIBLE;
    else this.psw_visibility_new = TextVisibility.HIDDEN;
  }

  getPswTypeNew(): string {
    if (this.psw_visibility_new == TextVisibility.HIDDEN) return 'password';
    else return 'text';
  }

  switchVisibilityRepeat() {
    if (this.psw_visibility_repeat == TextVisibility.HIDDEN)
      this.psw_visibility_repeat = TextVisibility.VISIBLE;
    else this.psw_visibility_repeat = TextVisibility.HIDDEN;
  }

  getPswTypeRepeat(): string {
    if (this.psw_visibility_repeat == TextVisibility.HIDDEN) return 'password';
    else return 'text';
  }

  // ==================================================
}
